import { FC, ReactNode } from 'react';
import { IconType } from 'react-icons';

import { WorkspaceResourceStatusTag } from '@/shared/components/workspace-resources/WorkspaceResourceStatus';

interface WorkspaceResourceListDescriptionProps {
    children: ReactNode;
    icon?: IconType;
}

/** Keeps compact list descriptions and their optional icons proportional and baseline-safe. */
export const WorkspaceResourceListDescription: FC<WorkspaceResourceListDescriptionProps> = ({
    children,
    icon: Icon,
}) => (
    <small style={{ alignItems: 'center', display: 'inline-flex', gap: '0.25rem', lineHeight: 1.4 }}>
        {Icon ? <Icon aria-hidden='true' size='0.875rem' style={{ flex: '0 0 auto' }} /> : null}
        <span>{children}</span>
    </small>
);

/** @deprecated Import WorkspaceResourceStatusTag for new shared status UI. */
export const WorkspaceResourceListStatusTag = WorkspaceResourceStatusTag;
